import { styled } from "sharedUI/styles";

export const BreadcrumbStyle = styled.div`
    display: flex;
    align-items: center;

    > * {
        margin-right: 4px;
    }

    .brcmb-item {
        transition: color ${p => p.theme.transitionBase};
        cursor: pointer;

        color: ${p => p.theme.textPale};
        font-weight: 800;
        font-size: 26px;

        &:hover,
        &:focus {
            color: ${p => p.theme.textBase};
        }

        & > div {
            margin-left: 4px;
            color: ${p => p.theme.iconPale};
        }
        > button {
            margin-left: 8px;
        }
    }

    .brcmb-current {
        color: ${p => p.theme.textDark};
    }

    .brcmb-editable {
        color: ${p => p.theme.textDark};
        transition: all ${p => p.theme.transitionBase};
        cursor: text;

        &:hover {
            box-shadow: 0 1px 0 ${p => p.theme.n400A};
        }
    }

    input {
        width: 200px;
        box-shadow: 0 1px 0 ${p => p.theme.b300};

        &:focus {
            color: ${p => p.theme.textBase};
        }
    }

    .edit-button {
        margin-left: 9px;
        display: flex;
        align-items: center;
        color: ${p => p.theme.fgColorMedium};

        :hover {
            cursor: pointer;
            color: ${p => p.theme.fgColorDark};
        }
    }
    .save-btn {
        margin-left: 8px;
    }
`;
